import React, { useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Tabs,
    Tab,
    Button,
    Grid,
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Divider,
    IconButton,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import {
    AddCircleOutline as AddIcon,
    CheckCircle as AcceptedIcon,
    Cancel as RejectedIcon,
    Send as SentIcon,
    Business as BrandIcon,
    CloudUpload as UploadIcon,
    InfoOutlined as InfoIcon,
    LibraryBooks as SectionIcon,
    Visibility as ViewIcon,
    FilePresent as FileIcon,
    AssignmentLate as ObsIcon,
    WarningAmber as WarningIcon,
    ErrorOutline as ErrorIcon,
    History as HistoryIcon
} from '@mui/icons-material';

const InformacionComercial = () => {
    const [tabValue, setTabValue] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        marca: '',
        tipoSolicitud: '',
        comentarios: '',
        motivos: [],
        comprobantePago: null,
        juegoEtiquetas: null
    });

    // Mock data for brands
    const mockBrands = [
        { 
            id: 1, 
            nombre: 'Mezcal Real', 
            status: 'Aceptada', 
            fecha: '2024-03-01',
            tipoSolicitud: 'Nacional',
            motivos: [1, 2],
            comentarios: 'Se requiere actualizar la etiqueta para el mercado nacional.',
            pagoPdfName: 'comprobante_pago_01.pdf',
            etiquetasPdfName: 'etiquetas_real_v2.pdf'
        },
        { 
            id: 2, 
            nombre: 'Alma de Maguey', 
            status: 'Enviada', 
            fecha: '2024-03-05',
            tipoSolicitud: 'Exportacion',
            motivos: [3],
            comentarios: 'Solicitud para exportación a la Unión Europea.',
            pagoPdfName: 'pago_exportacion.pdf',
            etiquetasPdfName: 'etiquetas_ue.pdf'
        },
        { 
            id: 3, 
            nombre: 'Destilado Sagrado', 
            status: 'Rechazada', 
            fecha: '2024-02-28',
            tipoSolicitud: 'Nacional',
            motivos: [4],
            comentarios: 'Información incorrecta en el registro anterior.',
            pagoPdfName: null,
            etiquetasPdfName: 'etiquetas_error.pdf',
            revisiones: [
                { requisito: "Presente en superficie principal de exhibición", estado: "fail", obs: "La marca no es visible en la cara principal de exhibición." },
                { requisito: "Registrada en CLASE 33", estado: "pass", obs: "" },
                { requisito: "Tipo: Nominativa / Mixta / Tridimensional", estado: "pass", obs: "" },
                { requisito: "Aislada de la marca", estado: "fail", obs: "La marca se encuentra encimada con el diseño de fondo, debe estar aislada." },
                { requisito: "Solo una: Joven, Repo, Añejo...", estado: "fail", obs: "Se seleccionaron dos categorías simultáneamente." },
                { requisito: "Incluye leyenda 'MEZCAL' junto a la marca", estado: "pass", obs: "" }
            ]
        },
        { 
            id: 4, 
            nombre: 'Esencia Purepecha', 
            status: 'Aceptada', 
            fecha: '2024-03-02',
            tipoSolicitud: 'Nacional',
            motivos: [1],
            comentarios: 'Cambio de presentación por nueva botella.',
            pagoPdfName: 'pago_botella.pdf',
            etiquetasPdfName: 'etiquetas_nuevas.pdf'
        },
        { 
            id: 5, 
            nombre: 'Viento del Sur', 
            status: 'Enviada', 
            fecha: '2024-03-08',
            tipoSolicitud: 'Exportacion',
            motivos: [2, 3],
            comentarios: 'Exportación a USA - Texas.',
            pagoPdfName: 'pago_usa.pdf',
            etiquetasPdfName: 'etiquetas_usa.pdf'
        },
    ];

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleOpenModal = () => {
        setIsEditing(false);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEditing(false);
        setFormData({
            marca: '',
            tipoSolicitud: '',
            comentarios: '',
            motivos: [],
            comprobantePago: null,
            juegoEtiquetas: null
        });
    };

    const handleOpenDetailModal = (brand) => {
        setSelectedBrand(brand);
        setOpenDetailModal(true);
    };

    const handleCloseDetailModal = () => {
        setOpenDetailModal(false);
        setSelectedBrand(null);
    };

    const handleEditRequest = (brand) => {
        setFormData({
            marca: brand.nombre,
            tipoSolicitud: brand.tipoSolicitud,
            comentarios: brand.comentarios,
            motivos: brand.motivos,
            comprobantePago: null,
            juegoEtiquetas: null
        });
        setIsEditing(true);
        setOpenModal(true);
        setOpenDetailModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        const value = parseInt(name);
        let newMotivos = [...formData.motivos];
        
        if (checked) {
            newMotivos.push(value);
        } else {
            newMotivos = newMotivos.filter(m => m !== value);
        }
        
        setFormData({ ...formData, motivos: newMotivos });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({ ...formData, [name]: files[0] });
    };

    const handleSubmit = () => {
        if (isEditing) {
            alert(`Solicitud corregida y re-enviada correctamente.`);
        } else {
            alert('Solicitud enviada correctamente. Su marca ha sido registrada.');
        }
        handleCloseModal();
    };

    const filteredBrands = mockBrands.filter(brand => {
        if (tabValue === 0) return brand.status === 'Enviada';
        if (tabValue === 1) return brand.status === 'Rechazada';
        if (tabValue === 2) return brand.status === 'Aceptada';
        return true;
    });

    const getStatusIcon = (status) => {
        switch (status) {
            case 'Aceptada': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#e8f5e9', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <AcceptedIcon sx={{ color: '#4caf50', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#4caf50', fontWeight: 'bold' }}>Aceptada</Typography>
                </Box>
            );
            case 'Rechazada': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#ffebee', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <RejectedIcon sx={{ color: '#f44336', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#f44336', fontWeight: 'bold' }}>Rechazada</Typography>
                </Box>
            );
            case 'Enviada': return (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#e3f2fd', borderRadius: '15px', px: 1, py: 0.5 }}>
                    <SentIcon sx={{ color: '#2196f3', fontSize: 18, mr: 0.5 }} />
                    <Typography variant="caption" sx={{ color: '#2196f3', fontWeight: 'bold' }}>Enviada</Typography>
                </Box>
            );
            default: return null;
        }
    };

    return (
        <div className='container2'>
            <Box sx={{ p: 4, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2b2b2b' }}>
                            Información Comercial
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={handleOpenModal}
                            sx={{
                                backgroundColor: '#c88b3e',
                                '&:hover': { backgroundColor: '#a67332' },
                                borderRadius: '20px',
                                px: 3
                            }}
                        >
                            Solicitar Informe
                        </Button>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        sx={{
                            mb: 3,
                            '& .MuiTabs-indicator': { backgroundColor: '#c88b3e' },
                            '& .Mui-selected': { color: '#c88b3e !important' }
                        }}
                    >
                        <Tab label="Enviadas" />
                        <Tab label="Rechazadas" />
                        <Tab label="Aceptadas" />
                    </Tabs>

                    <Grid container spacing={3}>
                        {filteredBrands.length > 0 ? (
                            filteredBrands.map((brand) => (
                                <Grid item xs={12} sm={6} md={4} key={brand.id}>
                                    <Card sx={{
                                        borderRadius: 2,
                                        borderLeft: `5px solid ${brand.status === 'Aceptada' ? '#4caf50' : brand.status === 'Rechazada' ? '#f44336' : '#2196f3'}`,
                                        transition: 'transform 0.2s',
                                        '&:hover': { transform: 'scale(1.02)' }
                                    }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                                <BrandIcon sx={{ color: '#c88b3e', fontSize: 40 }} />
                                                {getStatusIcon(brand.status)}
                                            </Box>
                                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                {brand.nombre}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                Fecha: {brand.fecha}
                                            </Typography>
                                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #f0f0f0', pt: 2 }}>
                                                <Button 
                                                    size="small" 
                                                    startIcon={<ViewIcon />}
                                                    onClick={() => handleOpenDetailModal(brand)}
                                                    sx={{ color: '#c88b3e', textTransform: 'none', fontWeight: 'bold' }}
                                                >
                                                    Ver Detalle
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Box sx={{ textAlign: 'center', py: 5 }}>
                                    <Typography variant="h6" color="textSecondary">
                                        No hay registros en esta categoría.
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Paper>

                {/* Modal para solicitar informe */}
                <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ 
                        background: 'linear-gradient(45deg, #2b2b2b 30%, #444444 90%)', 
                        color: 'white', 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1.5,
                        py: 2
                    }}>
                        {isEditing ? <WarningIcon sx={{ color: '#c88b3e' }} /> : <AddIcon sx={{ color: '#c88b3e' }} />}
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            {isEditing ? 'Corregir Solicitud' : 'Solicitar Nuevo Informe'}
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ mt: 1, p: 3 }}>
                        {isEditing && selectedBrand?.status === 'Rechazada' && selectedBrand.revisiones && (
                            <Box sx={{ mb: 3, p: 2, backgroundColor: '#fff5f5', border: '1px solid #ffcdd2', borderRadius: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                    <ErrorIcon sx={{ color: '#f44336', fontSize: 18 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#b71c1c' }}>
                                        OBSERVACIONES POR CORREGIR
                                    </Typography>
                                </Box>
                                <Box sx={{ pl: 3 }}>
                                    {selectedBrand.revisiones
                                        .filter(r => r.estado === 'fail')
                                        .map((rev, idx) => (
                                            <Typography key={idx} variant="caption" display="block" sx={{ color: '#d32f2f', mb: 0.5 }}>
                                                • <strong>{rev.requisito}:</strong> {rev.obs}
                                            </Typography>
                                        ))
                                    }
                                </Box>
                            </Box>
                        )}
                        <Grid container spacing={2.5}>
                            {/* Sección: Información General */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                                    <BrandIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        INFORMACIÓN GENERAL
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Seleccionar Marca"
                                    name="marca"
                                    value={formData.marca}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                >
                                    {mockBrands.filter(b => b.status === 'Aceptada').map((brand) => (
                                        <MenuItem key={brand.id} value={brand.nombre}>
                                            {brand.nombre}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Tipo de Informe"
                                    name="tipoSolicitud"
                                    value={formData.tipoSolicitud}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                >
                                    <MenuItem value="Nacional">Nacional</MenuItem>
                                    <MenuItem value="Exportacion">Exportación</MenuItem>
                                </TextField>
                            </Grid>

                            {/* Sección: Motivo de Revisión */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1, gap: 1 }}>
                                    <InfoIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        MOTIVO DE REVISIÓN
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 1 }} />
                                <FormControl component="fieldset" variant="standard" fullWidth>
                                    <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        <Grid container>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.includes(1)} onChange={handleCheckboxChange} name="1" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Cambio de presentación</Typography>}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.includes(2)} onChange={handleCheckboxChange} name="2" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Cambio de país</Typography>}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.includes(3)} onChange={handleCheckboxChange} name="3" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Cambio de destino</Typography>}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formData.motivos.includes(4)} onChange={handleCheckboxChange} name="4" sx={{ '&.Mui-checked': { color: '#c88b3e' } }} size="small" />}
                                                    label={<Typography variant="body2">Otros</Typography>}
                                                />
                                            </Grid>
                                        </Grid>
                                    </FormGroup>
                                </FormControl>
                            </Grid>

                            {/* Sección: Documentación */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1, gap: 1 }}>
                                    <UploadIcon sx={{ color: '#c88b3e', fontSize: 20 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                        DOCUMENTACIÓN Y ADJUNTOS
                                    </Typography>
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                            </Grid>

                            {formData.motivos.some(m => [1, 2, 3].includes(m)) && (
                                <Grid item xs={12}>
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        fullWidth
                                        startIcon={<UploadIcon />}
                                        sx={{ 
                                            textTransform: 'none',
                                            justifyContent: 'flex-start',
                                            borderColor: '#e0e0e0', 
                                            color: '#333', 
                                            py: 1.5,
                                            '&:hover': { borderColor: '#c88b3e', backgroundColor: 'rgba(200, 139, 62, 0.04)' } 
                                        }}
                                    >
                                        <Box sx={{ textAlign: 'left', width: '100%' }}>
                                            <Typography variant="caption" display="block" color="textSecondary">
                                                Comprobante de Pago (PDF)
                                            </Typography>
                                            <Typography variant="body2" noWrap>
                                                {formData.pagoPdf ? formData.pagoPdf.name : 'Subir archivo...'}
                                            </Typography>
                                        </Box>
                                        <input type="file" hidden accept="application/pdf" name="pagoPdf" onChange={handleFileChange} />
                                    </Button>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    startIcon={<UploadIcon />}
                                    sx={{ 
                                        textTransform: 'none',
                                        justifyContent: 'flex-start',
                                        borderColor: '#e0e0e0', 
                                        color: '#333', 
                                        py: 1.5,
                                        '&:hover': { borderColor: '#c88b3e', backgroundColor: 'rgba(200, 139, 62, 0.04)' } 
                                    }}
                                >
                                    <Box sx={{ textAlign: 'left', width: '100%' }}>
                                        <Typography variant="caption" display="block" color="textSecondary">
                                            Juego de Etiquetas (PDF/Imagen)
                                        </Typography>
                                        <Typography variant="body2" noWrap>
                                            {formData.etiquetasPdf ? formData.etiquetasPdf.name : 'Subir archivo...'}
                                        </Typography>
                                    </Box>
                                    <input type="file" hidden accept="application/pdf,image/*" name="etiquetasPdf" onChange={handleFileChange} />
                                </Button>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={2}
                                    label="Comentarios o Datos Adicionales"
                                    name="comentarios"
                                    placeholder="Ingrese cualquier información relevante adicional..."
                                    value={formData.comentarios}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0', backgroundColor: '#f9f9f9' }}>
                        <Button 
                            onClick={handleCloseModal} 
                            sx={{ color: '#666', fontWeight: 'bold', textTransform: 'none' }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            sx={{
                                backgroundColor: isEditing ? '#c88b3e' : '#2b2b2b',
                                '&:hover': { backgroundColor: isEditing ? '#a67332' : '#444' },
                                borderRadius: '25px',
                                px: 4,
                                textTransform: 'none',
                                fontWeight: 'bold',
                                boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                            }}
                        >
                            {isEditing ? 'Guardar Cambios y Re-enviar' : 'Enviar Solicitud'}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openDetailModal} onClose={handleCloseDetailModal} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ 
                        background: selectedBrand?.status === 'Rechazada' 
                            ? 'linear-gradient(45deg, #b71c1c 30%, #f44336 90%)' 
                            : 'linear-gradient(45deg, #2b2b2b 30%, #444444 90%)', 
                        color: 'white', 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1.5,
                        py: 2
                    }}>
                        {selectedBrand?.status === 'Rechazada' ? <WarningIcon sx={{ color: '#ffcdd2' }} /> : <ViewIcon sx={{ color: '#c88b3e' }} />}
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            {selectedBrand?.status === 'Rechazada' ? 'Solicitud Rechazada' : 'Detalle de Solicitud'}
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ mt: 0, p: 0 }}>
                        {selectedBrand && (
                            <>
                                {selectedBrand.status === 'Rechazada' && (
                                    <Box sx={{ backgroundColor: '#fff5f5', p: 2, display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid #ffcdd2' }}>
                                        <ErrorIcon sx={{ color: '#f44336', fontSize: 40 }} />
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#b71c1c' }}>
                                                Atención: Se han detectado inconsistencias
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#d32f2f' }}>
                                                Por favor revise las observaciones al final de este panel y realice las correcciones necesarias.
                                            </Typography>
                                        </Box>
                                    </Box>
                                )}
                                
                                <Box sx={{ p: 3 }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <Box>
                                                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2b2b2b' }}>
                                                        {selectedBrand.nombre}
                                                    </Typography>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                                        <Typography variant="caption" color="textSecondary">
                                                            Folio: #INF-{selectedBrand.id}00{selectedBrand.id}
                                                        </Typography>
                                                        <Divider orientation="vertical" flexItem sx={{ height: 12, my: 'auto' }} />
                                                        <HistoryIcon sx={{ fontSize: 14, color: '#666' }} />
                                                        <Typography variant="caption" color="textSecondary">
                                                            {selectedBrand.fecha}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                {getStatusIcon(selectedBrand.status)}
                                            </Box>
                                            <Divider sx={{ mt: 2 }} />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ fontWeight: 'bold' }}>
                                                TIPO DE INFORME
                                            </Typography>
                                            <Typography variant="body1" sx={{ fontWeight: 'medium', mt: 0.5 }}>
                                                {selectedBrand.tipoSolicitud}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ fontWeight: 'bold' }}>
                                                CANTIDAD DE MOTIVOS
                                            </Typography>
                                            <Typography variant="body1" sx={{ fontWeight: 'medium', mt: 0.5 }}>
                                                {selectedBrand.motivos.length} Motivos Seleccionados
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
                                                MOTIVOS DE REVISIÓN
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                {selectedBrand.motivos.map((m) => (
                                                    <Chip 
                                                        key={m} 
                                                        label={
                                                            m === 1 ? "Cambio de presentación" :
                                                            m === 2 ? "Cambio de país" :
                                                            m === 3 ? "Cambio de destino" : "Otros"
                                                        }
                                                        size="small"
                                                        sx={{ 
                                                            backgroundColor: 'rgba(200, 139, 62, 0.1)', 
                                                            color: '#c88b3e', 
                                                            fontWeight: 'bold',
                                                            border: '1px solid rgba(200, 139, 62, 0.2)'
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
                                                DOCUMENTACIÓN ADJUNTA
                                            </Typography>
                                            <Grid container spacing={2}>
                                                {selectedBrand.pagoPdfName && (
                                                    <Grid item xs={12} sm={6}>
                                                        <Paper variant="outlined" sx={{ 
                                                            p: 1.5, 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            gap: 1.5, 
                                                            cursor: 'pointer', 
                                                            borderRadius: 2,
                                                            '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#c88b3e' } 
                                                        }}>
                                                            <FileIcon sx={{ color: '#d32f2f' }} />
                                                            <Box>
                                                                <Typography variant="caption" display="block" color="textSecondary">Comprobante</Typography>
                                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }} noWrap>{selectedBrand.pagoPdfName}</Typography>
                                                            </Box>
                                                        </Paper>
                                                    </Grid>
                                                )}
                                                {selectedBrand.etiquetasPdfName && (
                                                    <Grid item xs={12} sm={6}>
                                                        <Paper variant="outlined" sx={{ 
                                                            p: 1.5, 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            gap: 1.5, 
                                                            cursor: 'pointer', 
                                                            borderRadius: 2,
                                                            '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' } 
                                                        }}>
                                                            <FileIcon sx={{ color: '#1976d2' }} />
                                                            <Box>
                                                                <Typography variant="caption" display="block" color="textSecondary">Etiquetas</Typography>
                                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }} noWrap>{selectedBrand.etiquetasPdfName}</Typography>
                                                            </Box>
                                                        </Paper>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>

                                        {selectedBrand.status === 'Rechazada' && selectedBrand.revisiones && (
                                            <Grid item xs={12}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 1, gap: 1 }}>
                                                    <ObsIcon sx={{ color: '#f44336', fontSize: 20 }} />
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#f44336' }}>
                                                        DETALLE DE LA RECHAZADA
                                                    </Typography>
                                                </Box>
                                                <Divider sx={{ mb: 2, borderColor: '#ffcdd2' }} />
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                    {selectedBrand.revisiones
                                                        .filter(r => r.estado === 'fail')
                                                        .map((rev, idx) => (
                                                            <Paper 
                                                                key={idx} 
                                                                elevation={0}
                                                                sx={{ 
                                                                    p: 2, 
                                                                    border: '1px solid #ffcdd2',
                                                                    borderLeft: '6px solid #f44336', 
                                                                    backgroundColor: '#fffcfc', 
                                                                    borderRadius: 2,
                                                                    position: 'relative',
                                                                    transition: 'all 0.2s',
                                                                    '&:hover': { boxShadow: '0 4px 12px rgba(244, 67, 54, 0.1)', transform: 'translateY(-2px)' }
                                                                }}
                                                            >
                                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                                                                    <ErrorIcon sx={{ fontSize: 16, color: '#f44336' }} />
                                                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#b71c1c' }}>
                                                                        {rev.requisito}
                                                                    </Typography>
                                                                </Box>
                                                                <Typography variant="body2" sx={{ color: '#555', pl: 3, lineBreak: 'anywhere' }}>
                                                                    {rev.obs}
                                                                </Typography>
                                                            </Paper>
                                                        ))
                                                    }
                                                </Box>
                                            </Grid>
                                        )}

                                        <Grid item xs={12}>
                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
                                                COMENTARIOS ADICIONALES
                                            </Typography>
                                            <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#fcfcfc', borderRadius: 2, borderStyle: 'dashed' }}>
                                                <Typography variant="body2" sx={{ fontStyle: selectedBrand.comentarios ? 'normal' : 'italic', color: selectedBrand.comentarios ? '#333' : '#999' }}>
                                                    {selectedBrand.comentarios || 'Sin comentarios adicionales.'}
                                                </Typography>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0', backgroundColor: '#f9f9f9' }}>
                        <Button 
                            onClick={selectedBrand?.status === 'Rechazada' ? () => handleEditRequest(selectedBrand) : handleCloseDetailModal} 
                            variant="contained"
                            sx={{
                                backgroundColor: selectedBrand?.status === 'Rechazada' ? '#f44336' : '#2b2b2b',
                                '&:hover': { backgroundColor: selectedBrand?.status === 'Rechazada' ? '#d32f2f' : '#444' },
                                borderRadius: '25px',
                                px: 4,
                                textTransform: 'none',
                                fontWeight: 'bold'
                            }}
                        >
                            {selectedBrand?.status === 'Rechazada' ? 'Corregir y Re-enviar' : 'Cerrar Detalles'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </div>
    );
};

export default InformacionComercial;
